import BaseMygocuApiService from './BaseMygocuApiService';

const USUARIO_API_VERSION = 'v1';
const USUARIO_API_BASEPATH_URL = '/usuario/' + USUARIO_API_VERSION;

class UsuarioApiService {
  doRegistro(usuarioRegistro) {
    const uUsuarioRegistroDTO = this._buildUUsuarioRegistroDTO(usuarioRegistro);
    return BaseMygocuApiService.post(USUARIO_API_BASEPATH_URL.concat('/registro'), uUsuarioRegistroDTO);
  }

  registrarYLoguear(usuarioRegistro) {
    const uUsuarioRegistroDTO = this._buildUUsuarioRegistroDTO(usuarioRegistro);
    return BaseMygocuApiService.post(USUARIO_API_BASEPATH_URL.concat('/registroAndLogin'), uUsuarioRegistroDTO);
  }

  getRegistroAndLoginFicticio(uuid) {
    return BaseMygocuApiService.get(USUARIO_API_BASEPATH_URL.concat('/registroAndLoginFicticio/' + uuid));
  }

  doRegistroAndLoginFicticio(uuid, usuarioRegistro) {
    const uUsuarioRegistroDTO = this._buildUUsuarioRegistroDTO(usuarioRegistro);
    return BaseMygocuApiService.post(
      USUARIO_API_BASEPATH_URL.concat('/registroAndLoginFicticio/' + uuid),
      uUsuarioRegistroDTO
    );
  }

  activarUsuario(codigo, password) {
    const uPasswordDTO = this._buildUPasswordDTO(password);
    return BaseMygocuApiService.put(USUARIO_API_BASEPATH_URL.concat('/activar/' + codigo), uPasswordDTO);
  }

  recordarPassword(email) {
    return BaseMygocuApiService.put(USUARIO_API_BASEPATH_URL.concat('/password/recordar/' + email));
  }

  registrarGoogle(usuarioRegistro) {
    const uUsuarioRegistroDTO = this._buildUUsuarioRegistroGoogleDTO(usuarioRegistro);

    return BaseMygocuApiService.post(USUARIO_API_BASEPATH_URL.concat('/registroGoogle'), uUsuarioRegistroDTO);
  }

  registrarYLoguearGoogle(usuarioRegistro) {
    const uUsuarioRegistroDTO = this._buildUUsuarioRegistroGoogleDTO(usuarioRegistro);
    return BaseMygocuApiService.post(USUARIO_API_BASEPATH_URL.concat('/registroAndLoginGoogle'), uUsuarioRegistroDTO);
  }

  reestablecerPassword(codigo, password) {
    const uPasswordDTO = this._buildUPasswordDTO(password);
    return BaseMygocuApiService.put(USUARIO_API_BASEPATH_URL.concat('/password/reestablecer/' + codigo), uPasswordDTO);
  }

  validateEmail(emailUser) {
    return BaseMygocuApiService.get(USUARIO_API_BASEPATH_URL.concat(`/email/validar?email=${emailUser}`));
  }

  addAccesoLink(comercialId) {
    return BaseMygocuApiService.post(USUARIO_API_BASEPATH_URL.concat(`/accesosLink?comercial=${comercialId}`));
  }

  modificarDatosUsuario(usuario) {
    return BaseMygocuApiService.put(USUARIO_API_BASEPATH_URL.concat('/datos'), this._buildUUsuarioDTO(usuario));
  }

  modificarDatosFiscales(datosFiscales) {
    return BaseMygocuApiService.post(
      USUARIO_API_BASEPATH_URL.concat('/datos/fiscales'),
      this._buildUDatosFiscalesDTO(datosFiscales)
    );
  }

  obtenerDatosUsuario() {
    return BaseMygocuApiService.get(USUARIO_API_BASEPATH_URL.concat('/datos'));
  }

  modificarPassword(passwordEdicion) {
    return BaseMygocuApiService.put(
      USUARIO_API_BASEPATH_URL.concat('/datos/password'),
      this._buildUPasswordEdicionDTO(passwordEdicion)
    );
  }

  doBajaUsuario() {
    return BaseMygocuApiService.put(USUARIO_API_BASEPATH_URL.concat('/baja'));
  }

  getPaisesOpts() {
    return BaseMygocuApiService.get(USUARIO_API_BASEPATH_URL.concat('/paises'));
  }

  darBajaPublicidad(codigo) {
    return BaseMygocuApiService.put(USUARIO_API_BASEPATH_URL.concat('/datos/publicidad/baja/' + codigo));
  }

  uploadDniImages(formDNI) {
    const config = {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    };
    return BaseMygocuApiService.post(USUARIO_API_BASEPATH_URL.concat('/datos/dni'), formDNI, config);
  }

  //////////////////////
  // PRIVATE BUILDERS //
  //////////////////////

  _buildUUsuarioRegistroDTO(usuarioRegistro) {
    return {
      nombre: usuarioRegistro.nombre,
      apellidos: usuarioRegistro.apellidos,
      telefono: usuarioRegistro.telefono,
      email: usuarioRegistro.email,
      emailConfirm: usuarioRegistro.emailConfirm,
      fechaNacimiento: usuarioRegistro.fechaNacimiento,
      password: usuarioRegistro.password,
      mailingPublicidadActivo: usuarioRegistro.mailingPublicidadActivo,
    };
  }

  _buildUPasswordDTO(password) {
    return {
      password: password.password,
      passwordConfirm: password.passwordConfirm,
    };
  }

  _buildUUsuarioDTO(usuario) {
    return {
      nombre: usuario.nombre,
      apellidos: usuario.apellidos,
      telefono: usuario.telefono,
      email: usuario.email,
      emailConfirm: usuario.emailConfirm,
      fechaNacimiento: usuario.fechaNacimiento,
      tipoDocumento: usuario.tipoDocumento,
      dni: usuario.dni,
      numSoporte: usuario.numSoporte,
      direccion: usuario.direccion,
      paisId: usuario.paisId,
      paisCode: usuario.paisCode,
      provincia: usuario.provincia,
      poblacion: usuario.poblacion,
      codigoPostal: usuario.codigoPostal,
      mailingPublicidadActivo: usuario.mailingPublicidadActivo,
    };
  }

  _buildUPasswordEdicionDTO(passwordEdicion) {
    return {
      password: passwordEdicion.password,
      passwordConfirm: passwordEdicion.passwordConfirm,
      oldPassword: passwordEdicion.oldPassword,
    };
  }

  _buildUUsuarioRegistroGoogleDTO(usuarioRegistro) {
    return {
      authCode: usuarioRegistro.code,
    };
  }

  _buildUDatosFiscalesDTO(datosFiscales) {
    return {
      id: datosFiscales.id,
      tipo: datosFiscales.tipo,
      idFiscal: datosFiscales.idFiscal,
      razonSocial: datosFiscales.razonSocial,
      nombre: datosFiscales.nombre,
      apellidos: datosFiscales.apellidos,
      direccion: datosFiscales.direccion,
      paisCode: datosFiscales.paisCode,
      provincia: datosFiscales.provincia,
      poblacion: datosFiscales.poblacion,
      codigoPostal: datosFiscales.codigoPostal,
      telefono: datosFiscales.telefono,
      email: datosFiscales.email,
    };
  }
}

export default new UsuarioApiService();
